<template>
  <div class="field-help-label" :class="{ 'field-help-label--active': content.hasContent }">
    <label v-if="inputId" :for="inputId">{{ label }}</label>
    <span v-else>{{ label }}</span>
    <FieldHelp v-if="content.hasContent" :help="content" :label="label" :field-id="fieldId" :modal-key="modalKey" />
  </div>
</template>

<script>
import FieldHelp from './FieldHelp.vue'
import { normalizeFieldHelp } from './helpContent'

export default {
  name: 'FieldLabel',
  components: { FieldHelp },
  props: {
    label: { type: String, default: '' },
    help: { type: Object, default: null },
    inputId: { type: String, default: '' },
    fieldId: { type: [Number, String], default: null },
    modalKey: { type: String, default: '' },
  },
  computed: {
    content() { return normalizeFieldHelp(this.help) },
  },
}
</script>

<style scoped>
.field-help-label { display: flex; align-items: center; gap: 4px; min-width: 0; }
.field-help-label--active { font-size: 13px; line-height: 22px; margin: 0; color: #626b76; }
.theme--dark .field-help-label--active { color: #b6bec9; }
.field-help-label > label, .field-help-label > span { min-width: 0; overflow-wrap: anywhere; }
.field-help-label > label { cursor: pointer; }
</style>

<style>
/* Le libellé fixe remplace la réserve du libellé flottant, sans masquer les validations. */
.field-help-label.field-help-label--active ~ .v-input.v-text-field,
.field-help-label.field-help-label--active + .field-text > .v-text-field,
.field-help-label.field-help-label--active + .field-textarea > .v-text-field,
.field-help-label.field-help-label--active + .field-conversion__row > .v-text-field {
  margin: 0;
  padding-top: 0;
}

/* Rapprocher la saisie simple du libellé externe, sans superposer les textes. */
.field-help-label.field-help-label--active ~ .v-input.v-text-field:not(.v-text-field--enclosed):not(.v-input--dense),
.field-help-label.field-help-label--active + .field-text > .v-text-field:not(.v-text-field--enclosed):not(.v-input--dense),
.field-help-label.field-help-label--active + .field-textarea > .v-text-field:not(.v-text-field--enclosed):not(.v-input--dense),
.field-help-label.field-help-label--active + .field-conversion__row > .v-text-field:not(.v-text-field--enclosed):not(.v-input--dense) {
  margin-top: -8px;
}

.field-help-label.field-help-label--active ~ .v-autocomplete.v-select--chips:not(.v-text-field--enclosed):not(.v-input--is-dirty):not(.v-input--is-focused) > .v-input__control > .v-input__slot > .v-select__slot > .v-select__selections {
  min-height: 24px;
}
</style>
